import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import {
  Box,
  Grid, styled, TextField, TextFieldProps, Typography,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import frLocale from 'date-fns/locale/fr';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React from 'react';

function CalendarCustom({
  control, name, label, rules = null, size = 'medium', variant = 'standard', maxDate, minDate,
}: any) {
  const errorMessage = "La date n'est pas valide";
  return (
    <Grid item height={80}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, fieldState }) => {
          return (
            <Box>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={frLocale}
              >
                <DesktopDatePicker
                  {...field}
                  value={field.value || null}
                  label={label}
                  onChange={(e: any) => {
                    field.onChange(e);
                  }}
                  maxDate={maxDate}
                  minDate={minDate}
                  renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
                    <CssAutocomplete
                      {...params}
                      size={size}
                      fullWidth
                      color="secondary"
                      variant={variant}
                    />
                  )}
                />
                {fieldState?.error?.message && <Typography variant="caption" fontWeight="bold" color="error">{fieldState.error.message}</Typography>}
                {fieldState?.error?.type === 'validate' && <Typography variant="caption" fontWeight="bold" color="error">{errorMessage}</Typography>}
              </LocalizationProvider>
            </Box>
          );
        }}
      />
    </Grid>
  );
}

const CssAutocomplete = styled(TextField)(({ theme }) => ({
  label: {
    fontWeight: '400',
    color: theme.palette.text.primary,
  },
}));

export {
  CalendarCustom,
};
